/*
 * Declare Algolia Container.
 */
var AL = AL || {};

/*
 * Anonymus init function.
 */
(function ($) {

    /*
     * Search Helper Settings.
     */
    AL.settings = {
        appId: 'TK2MYWX8R4',
        appKey: '8068134b13ed780a7d3f02c0769f7875',
        googleApiKey: 'AIzaSyAd48rcKKj3PUXti2XXU0VDxbrwsE7bNvs',
        regexZipCodeCanada: /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ])( )?(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/i,
        regexZipCodeCanadaWithNoSpace: /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ])(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/i,
        regexZipCodeUSA: /(^\d{5}$)|(^\d{5}-\d{4}$)/
    };

    /*
     * Algolia core jQuery plugin.
     */
    $.fn.algolia = function (options) {

        var defaults = {
            multipleIndexes: false,
            singleIndexName: 'find-a-teacher',
            appId: AL.settings.appId,
            appKey: AL.settings.appKey,
            regexZipCodeCanada: AL.settings.regexZipCodeCanada,
            regexZipCodeCanadaWithNoSpace: AL.settings.regexZipCodeCanadaWithNoSpace,
            regexZipCodeUSA: AL.settings.regexZipCodeUSA,
            googleApiKey: AL.settings.googleApiKey,
            hitsPerPage: 1000,
            attributesToSnippet: [],
            facets: [],
            onReady: function () {},
            formValidation: function () { return true; },
            onSubmit: function () {},
            onResults: function () {}
        };

        var settings = $.extend({}, defaults, options);

        var client = algoliasearch(settings.appId, settings.appKey);

        window.algoliaContainer = {
            obj: this,
            type: this.data('algo'),
            indexName: this.data('algoIndex') || settings.singleIndexName,
            index: false,
            config: settings,
            geofield: this.data('algoGeofield') || false,
            georadiusfield: this.data('algoGeoradiusfield') || false
        };

        window.algoliaContainer.index = client.initIndex(window.algoliaContainer.indexName);

        window.algoliaWaitingListCounter = 0;

        // Check all Algolia inputs
        $(':input', window.algoliaContainer.obj).filter(function () {
            return $(this).data('algo') !== undefined;
        }).each(function () {
            var type = $(this).data('algo');

            // Facet field
            if ('facet' == type) {
                var facetName = $(this).data('algoFacet');
                var populate = $(this).data('algoFacetPopulate') || false;
                var defaultValue = $(this).data('algoDefaultValue') || false;

                if (populate) {
                    window.algoliaWaitingListCounter++;
                    populateFacet(settings, $(this), facetName, defaultValue);
                }
            // Zip code field
            } else if ('zipcode' == type) {
                $(this).on('input', function () {
                    var field = $(this);
                    var val = $.trim(field.val());
                    var region = 'ca';

                    // Reset the state
                    field.data('algoGeoConverted', false);
                    field.data('algoGeoLoading', false);

                    // Check regex Canada - if there is a space between the 3 first and 3 last digits, it removes the space (so Google will find the address)
                    if (settings.regexZipCodeCanada.test(val) && !settings.regexZipCodeCanadaWithNoSpace.test(val)) {
                        val = val.replace(settings.regexZipCodeCanada, '$1$3');
                    }

                    if (settings.regexZipCodeUSA.test(val)) {
                        region = 'us';
                    }

                    // Check regex Canada and US
                    if (settings.regexZipCodeCanada.test(val) || settings.regexZipCodeUSA.test(val)) {
                        field.data('algoGeoLoading', true);
                        field.parent().addClass('loading');
                        field.attr('disabled', 'disabled');

                        $.getJSON('https://maps.googleapis.com/maps/api/geocode/json?address=' + val + '&region=' + region + '&key=' + settings.googleApiKey, function (data) {
                            field.data('algoGeoLoading', false);
                            field.parent().removeClass('loading');
                            field.removeAttr('disabled');

                            if ('OK' == data.status) {
                                field.data('algoGeoConverted', true);
                                field.data('algoGeoLat', data.results[0].geometry.location.lat);
                                field.data('algoGeoLon', data.results[0].geometry.location.lng);
                            } else {
                                // Problem converting the zipcode to lat lon
                            }

                            // Callback
                            if (true == field.data('submitFormOnCallback')) {
                                field.data('submitFormOnCallback', false);
                                window.algoliaContainer.obj.trigger('fake-submit');
                            }
                        });
                    } else {
                        // Bad ZipCode
                    }
                });
            }
        });

        // Fake submit because Kentico doesn't allow other forms on the page
        window.algoliaContainer.obj.find('[type="submit"]').on('click', function (e) {
            e.preventDefault();
            window.algoliaContainer.obj.trigger('fake-submit');
        });

        // On serch form submit
        window.algoliaContainer.obj.on('fake-submit', function (e) {
            e.preventDefault();

            // Zipcode field
            var zipcodeField = $(':input', window.algoliaContainer.obj).filter(function () {
                return $(this).data('algo') !== undefined && $(this).data('algo') == 'zipcode';
            });

            // If the zipcode was not converted yet into geolocation
            if (true == zipcodeField.data('algoGeoLoading') && false == zipcodeField.data('algoGeoConverted')) {
                zipcodeField.data('submitFormOnCallback', true);
                return false;
            }

            if (false == settings.formValidation.call(this, window.algoliaContainer.obj)) {
                return false;
            }

            var query = '';
            if (window.algoliaContainer.obj.find('[name="search"]').length > 0) {
                query = $.trim(window.algoliaContainer.obj.find('[name="search"]').val());
            }

            var page = 0;
            if (window.algoliaContainer.obj.find('.alg-page').length > 0) {
                page = parseInt(window.algoliaContainer.obj.find('.alg-page').val()) - 1;
            }

            settings.onSubmit.call(this);
            search(settings, query, page);
        });

        if (0 == window.algoliaWaitingListCounter) {
            settings.onReady.call(this, window.algoliaContainer.obj);
        }
    };

    /*
     * Populate Algolia facets.
     */
    function populateFacet(settings, field, facetName, defaultValue) {
        if (defaultValue) {
            $('<option/>').val('').text(defaultValue).appendTo(field);
        }

        window.algoliaContainer.index.searchForFacetValues({
            facetName: facetName,
            facetQuery: '',
            maxFacetHits: 100,
            sortFacetValuesBy: 'alpha'
        }, function (err, content) {
            if (err) {
                console.error(err);
                return;
            }

            window.algoliaWaitingListCounter--;

            $(content.facetHits).each(function (i, v) {
                $('<option/>').val(v.value).text(v.value).appendTo(field);
            });

            if (0 == window.algoliaWaitingListCounter) {
                settings.onReady.call(this, window.algoliaContainer.obj);
            }
        });
    }

    /*
     * Algolia Search.
     */
    function search(settings, query, page) {
        // Search parameter
        window.algoliaSearchSettings = {
            query: query,
            page: page,
            hitsPerPage: settings.hitsPerPage,
            attributesToSnippet: settings.attributesToSnippet,
            facets: settings.facets,
            facetFilters: [],
            numericFilters: []
        };

        // Facet filters
        var facetFilters = [];
        var numericFilters = [];

        $('[data-algo="facet"]', window.algoliaContainer.obj).each(function () {
            var f = $(this);
            var fName = f.data('algoFacet') || f.data('algofacet');
            var fValue = f.val();
            var fCompareSymbol = f.data('algoFacetCompareSymbol') || ':';
            var fType = f.data('algoFacetType') || '';

            if (fName && fValue) {
                if (fType == 'numeric') {
                    numericFilters.push(fName + fCompareSymbol + fValue);
                } else {
                    facetFilters.push(fName + fCompareSymbol + fValue);
                }
            }
        });

        if (facetFilters.length > 0) {
            window.algoliaSearchSettings.facetFilters = facetFilters;
        }

        if (numericFilters.length > 0) {
            window.algoliaSearchSettings.numericFilters = numericFilters;
        }

        // Check if the current search is a Geospatial Search
        if ('geo' == window.algoliaContainer.type) {
            var geofield = $(window.algoliaContainer.geofield);
            var georadiusfield = $(window.algoliaContainer.georadiusfield);
            var lat = geofield.data('algoGeoLat');
            var lng = geofield.data('algoGeoLon');
            var radius = georadiusfield.val() || 5000;

            if (settings.regexZipCodeUSA.test(geofield.val())) {
                // Convert KM (in meters) to mi
                radius = (radius / 1000 * 1609.34).toFixed();
            }

            if (lat && lng) {
                window.algoliaSearchSettings.aroundLatLng = lat + ', ' + lng;
                window.algoliaSearchSettings.aroundRadius = radius;
                window.algoliaSearchSettings.getRankingInfo = true;
            }
        }

        // Do the search
        window.algoliaContainer.index.search(window.algoliaSearchSettings, function searchDone(err, content) {
            if (err) {
                console.error(err);
                return;
            }

            settings.onResults.call(this, content);
        });
    }

})(jQuery);
